module.exports = "https://static.energy5.com/_next/static/images/retailBgEffect-246bfb3646a3726f1864c917ebaa52da.webp";